import {
    AccessibilityChartColors,
    AccessibilityGradientCategoryColors,
    AccessibilityGradientNumericColors,
    AccessibilityNamedColors,
} from './theme-colors';

export const DEFAULT_ACCESSIBILITY_THEME = {
    name: 'default_accessibility',
    base: null,
    variables: {
        chartColors: [
            AccessibilityChartColors.color1, // 0 (figma color 11)
            AccessibilityChartColors.color2, // 1 (figma color 9)
            AccessibilityChartColors.color3, // 2 (figma color 2)
            AccessibilityChartColors.color4, // 3 (figma color 8)
            AccessibilityChartColors.color5, // 4 (figma color 1)
            AccessibilityChartColors.color11, // 5 (figma color 4) // waring color
            AccessibilityChartColors.color8, // 6 (figma color 3)
            AccessibilityChartColors.color12, // 7 (figma color 12)
            AccessibilityChartColors.color9, // 8 (figma color 7)
            '#424d69', // 9
            AccessibilityChartColors.color10, // 10 (figma color 13)
            AccessibilityChartColors.color7, // 11 (figma color 14)
            AccessibilityChartColors.color13, // 12 (figma color 15)
            AccessibilityChartColors.color6, // 13 (figma color 6)
            '#ffd5de', // 14
            '#b4e9db', // 15
            '#fef3d5', // 16
            '#eabeff', // 17
            '#cae5ff', // 18
            '#e9f4b1', // 19
            '#ffe6b3', // 20
            '#d6d3ff', // 21
            '#c1eef2', // 22
            '#e4e6eb', // 23
            '#424d69', // 24
            '#879ac3', // 25
            AccessibilityChartColors.color14, // 26 (figma color 5),
            AccessibilityChartColors.color15, // 27 (figma color 10),
        ],
        namedColors: {
            empty: AccessibilityNamedColors.grey,
            gradientCategory: {
                color1: AccessibilityGradientCategoryColors.color1,
                color2: AccessibilityGradientCategoryColors.color2,
                color3: AccessibilityGradientCategoryColors.color3,
                color4: AccessibilityGradientCategoryColors.color4,
                color5: AccessibilityGradientCategoryColors.color5,
            },
            gradientNumeric: {
                color1: AccessibilityGradientNumericColors.color1,
                color2: AccessibilityGradientNumericColors.color2,
                color3: AccessibilityGradientNumericColors.color3,
                color4: AccessibilityGradientNumericColors.color4,
                color5: AccessibilityGradientNumericColors.color5,
            },
        },

        alertStatuses: [
            '#C5CCDB', //0
            '#579FE6', //1
            '#2670FF', //2
            '#EDE98F', //3
            '#F8BD79', //4
            '#FAB0D3', //5
            '#ED7B68', //6
        ],

        demandFactors: [
            '#579FE6', //0
            '#C2ECFF', //1
            '#00B383', //2
            '#D5F2C4', //3
            '#FAD36D', //4
            '#FFF8BF', //5
            '#FFB660', //6
            '#FFCF96', //7
            '#FF708D', //8
            '#FFC9D5', //9
        ],

        batteryBankModel: {
            MARGINAL: '#EE8EB6',
            FAILURE: '#cc473d',
            REFERENCE: '#F19F64',
            REPLACEMENT: '#0039c1',
            seriesItems: [
                '#F19F64',
                '#0087FE',
                '#5CB2FE',
                '#A3D4FE',
                '#D6ECFF',
                '#232986',
                '#4F549F',
                '#B0B2D4',
                '#DCDDEC',
            ],
            axisLines: '#E0E6F1',
        },

        primary_default: '#fe9339',
        secondary_default: '#0c8ac7',
        warning_default: '#f9bf4c',
        warn_default: '#f0735b',

        fontColor: '#202840',
        fontHintColor: '#9fa9bd',
        backgroundChartColor: '#fff',
        backgroundBasicColor1: '#fff',

        tooltipBg: '#ffffff',

        axisSliderBackground: '#ffffff', // color-basic-100
        axisSliderShadow: '#c5ccdb', // color-basic-500
        axisSliderHandle: '#9fa9bd', // color-basic-600

        axisNameText: '#8992A3',
        axisLine: '#e0e6f1',

        tableFilterBg: '#ffffff',
        tableFilterColor: '#2a344f',

        new_data_color: '#424d69',
        old_data_color: '#a6aebd',
    },
};
